/*
  Появление и исчезновение выпадающего списка.

  Вынесено из `Select.jsx` 14.09.2026, когда такой же список понадобился полю с
  ручным вводом (`CourtField.jsx`). Два списка кабинета обязаны открываться
  одинаково: разная скорость или разный способ читаются как разные элементы
  интерфейса при одинаковом смысле.

  Нужны ДВА признака, а не один. `mounted` держит список в разметке, пока идёт
  исчезновение: убрать его сразу - и закрытие было бы рывком. `shown` включает
  классы перехода, и включается он ПОСЛЕ первой отрисовки, иначе браузеру нечего
  анимировать - он увидит сразу конечное состояние.
*/

import { useEffect, useState } from 'react'

// Столько же длится появление и исчезновение списка в `styles.css`. Разъедься
// они, список исчезал бы рывком или висел бы пустым.
export const ANIMATION_MS = 150

export default function useReveal(open) {
  const [mounted, setMounted] = useState(false)
  const [shown, setShown] = useState(false)

  useEffect(() => {
    if (open) {
      setMounted(true)
      const frame = requestAnimationFrame(() => setShown(true))
      return () => cancelAnimationFrame(frame)
    }
    setShown(false)
    const timer = setTimeout(() => setMounted(false), ANIMATION_MS)
    return () => clearTimeout(timer)
  }, [open])

  return { mounted, shown }
}
